var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 60,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "svg-fill-75",
    fill: "#2E7C87",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.083,
    d: "M51.054 57.078c11.594 0 17.736-7.417 27.118-9.106 19.247-3.464 36.942-3.52 36.942-10.977 0-4.701-21.582-.395-29.254-5.225-6.162-3.88 2.863-17.276-7.688-18.59-7.31-.909-18.776 3.731-27.118 3.731-18.088 0-34.272.466-45.92 4.245-11.136 3.613 0 10.418 0 15.839 0 8.27-8.75 19.262 14.025 22.34 7.772 1.051 22.894-2.257 31.895-2.257z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.514.74c11.575 0 20.957 9.381 20.957 20.957 0 5.035-1.776 9.656-4.735 13.27L75.558 49.79a2.087 2.087 0 01-2.717 3.152l-.234-.202-14.822-14.823a20.872 20.872 0 01-13.271 4.736c-11.577.001-20.958-9.381-20.958-20.956C23.557 10.12 32.938.739 44.514.739zm0 4.172c-9.271 0-16.785 7.514-16.785 16.785 0 9.27 7.514 16.784 16.785 16.784 9.27 0 16.784-7.514 16.784-16.784 0-9.271-7.514-16.785-16.784-16.785z"
  }))));
}

export default SvgSearch;